import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const Row = styled.div`
  height: 72px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.border.light} 0%,
    ${({ theme }) => `${theme.colors.border.light}88`} 50%,
    ${({ theme }) => theme.colors.border.light} 100%
  );
  animation: ${pulse} 1.4s ease-in-out infinite;
`;
